import type { Rule } from 'effector-forms'

export type ValidatorNames =
  | 'required'
  | 'password'
  | 'username'
  | 'withoutSpecSymbols'
  | 'minLength'
  | 'maxLength'
  | 'equalTo'
  | 'digits'

export const passThrough = (name): Rule<string | number> => ({
  name,
  validator: () => true,
})

export const required = (): Rule<string> => ({
  name: 'required',
  validator: (value) => Boolean(value),
})

export const email = (): Rule<string> => ({
  name: 'email',
  validator: (value) => /.+@.+\..+$/.test(value),
})

export const password = {
  name: 'password',
  validator(regex: RegExp) {
    return {
      name: this.name,
      validator: (value) => regex.test(value),
    } as Rule<string>
  },
}

export const username = (): Rule<string> => ({
  name: 'username',
  validator: (value) => /^[A-Za-z0-9#$_&\-*!?.\s]+$/.test(value),
})

export const withoutSpecSymbols = (): Rule<string> => ({
  name: 'withoutSpecSymbols',
  validator: (value) => /^[-\p{L}0-9\s'`]+$/u.test(value),
})

export const minLength = {
  name: 'minLength',
  validator(min: number) {
    return {
      name: this.name,
      validator: (value) => value.length >= min,
    }
  },
}

export const maxLength = {
  name: 'maxLength',
  validator(max: number) {
    return {
      name: this.name,
      validator: (value) => value.length <= max,
    }
  },
}

export const equalTo = (field: string): Rule<string> => ({
  name: 'equalTo',
  validator: (value, form) => value === form[field],
})

export const digits = (): Rule<string> => ({
  name: 'digits',
  validator: (value) => /^\d+$/.test(value),
})
